import { StringType } from '@hb/map-convert';
/**
 * 入参转换
 */
export var queryType = {
    ipAddr: StringType('ip'),
};
export var dataType = {
    city: StringType(),
    province: StringType(),
    adcode: StringType(),
    rectangle: StringType(),
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udmVydC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb3JlL2FtYXAvaXBMb2NhdGUvY29udmVydC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsVUFBVSxFQUFFLE1BQU0saUJBQWlCLENBQUM7QUFHN0M7O0dBRUc7QUFDSCxNQUFNLENBQUMsSUFBTSxTQUFTLEdBQWdCO0lBQ3BDLE1BQU0sRUFBRSxVQUFVLENBQUMsSUFBSSxDQUFDO0NBQ3pCLENBQUM7QUFFRixNQUFNLENBQUMsSUFBTSxRQUFRLEdBQWdCO0lBQ25DLElBQUksRUFBRSxVQUFVLEVBQUU7SUFDbEIsUUFBUSxFQUFFLFVBQVUsRUFBRTtJQUN0QixNQUFNLEVBQUUsVUFBVSxFQUFFO0lBQ3BCLFNBQVMsRUFBRSxVQUFVLEVBQUU7Q0FDeEIsQ0FBQyJ9